import { gql, useLazyQuery } from "@apollo/client"
import { User } from "@oysterhr/schema"

const GET_SESSION = gql`
  query GetSessionQuery {
    me {
      id
    }
  }
`

export const useSessionQuery = () =>
  useLazyQuery<{ me: User }>(GET_SESSION, { fetchPolicy: "network-only" })
